import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Button from '../../../../1stlog-ui/src/components/Button'
import Input from '../../../../1stlog-ui/src/components/Input'
import { validateSearch } from './validate'

const Wrapper = styled.div`
  display: flex;
`

const Search = (props) => {
  const { search, setSearch } = props

  const [value, setValue] = useState(search)

  const clear = () => {
    setValue('')
    setSearch('')
  }

  useEffect(() => {
    setValue(search)
  }, [search])

  const apply = () => setSearch(value)

  const isValid = useMemo(() => !validateSearch(value), [value])

  return (
    <Wrapper>
      <div className="flex-fill mr-2">
        <Input
          onEnter={apply}
          block
          value={value}
          onChange={setValue}
          placeholder={i18n.t('search_custom_nmb', 'Zolltarife durchsuchen...')}
          onClear={clear}
        />
      </div>
      <div>
        <Button info icon="fas fa-search" onClick={apply} disabled={!isValid} />
      </div>
    </Wrapper>
  )
}

export default Search
